module.exports = __webpack_public_path__ + "static/media/back-new-8.00a05901.jpg";